import { IconButton, Typography, makeStyles } from '@material-ui/core';
import React from 'react'

const useStyles=makeStyles({
    button:{
        '& .MuiIconButton-label':{
            display:'flex',
            flexDirection:'column'
        }
    }
})

export default function ToolsRenderer(params:any) {
    const tools=params.value;
    const styles=useStyles();
    
  return (
    <div style={{display:'flex'}}>
        {tools && tools.map((tool:any,key:number)=>(
            <div>
                <IconButton className={styles.button} onClick={()=>{
                    window.open(tool.url,'_blank')
                }}>
                    {tool.icon}
                    <Typography>
                    {tool.name}
                </Typography>
                </IconButton>
                
            </div>
        ))}
    </div>
  )
}
